<template>
    <div :class="className" :style="{height:height,width:width}"/>
</template>

<script>
    import echarts from 'echarts'

    require('echarts/theme/macarons')  // echarts theme
    import resize from './mixins/resize'

    export default {
        mixins: [resize],
        props: {
            className: {
                type: String,
                default: 'chart'
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '360px'
            },
            chartData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                chart: null
            }
        },
        watch: {
            chartData: {
                deep: true,
                handler(val) {
                    this.setOptions(val)
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initChart()
            })
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            this.chart.dispose()
            this.chart = null
        },
        methods: {
          initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            this.setOptions(this.chartData)
          },

          setOptions({occupyRate, freeRate, occupyHourOne, occupyHourTwo,occupyHourSix,occupyHourTwelve,occupyHourTwentyFour,occupyHourN} = {}) {
                this.chart.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },

                    legend: {
                        left: 'center',
                        bottom: '10',
                        data: ['充电柜占用率', '充电柜空闲率']
                    },
                    series: [
                        {
                            name: '',
                            type: 'pie',
                            selectedMode: 'single',
                            radius: [0, '25%'],
                            center: ['50%', '45%'],
                            label: {
                                position: 'inner',
                                fontSize: 14,
                                formatter: '{b}',
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                {value: occupyRate, name: '充电柜占用率'},
                                {value: freeRate, name: '充电柜空闲率'},
                            ]
                        },
                        // {
                        //     name: '',
                        //     type: 'pie',
                        //     radius: ['38%', '55%'],
                        //     center: ['50%', '45%'],
                        //     labelLine: {
                        //         length: 30,
                        //     },
                        //     label: {
                        //         backgroundColor: '#F6F8FC',
                        //         borderColor: '#8C8D8E',
                        //         borderRadius: 4,
                        //         formatter: '{b} ',
                        //         rich: {
                        //             a: {
                        //                 color: '#6E7079',
                        //                 lineHeight: 22,
                        //                 align: 'center'
                        //             },
                        //             hr: {
                        //                 borderColor: '#8C8D8E',
                        //                 width: '100%',
                        //                 borderWidth: 1,
                        //                 height: 0
                        //             },
                        //             b: {
                        //                 color: '#4C5058',
                        //                 fontSize: 14,
                        //                 fontWeight: 'bold',
                        //                 lineHeight: 33
                        //             },
                        //             per: {
                        //                 color: '#fff',
                        //                 backgroundColor: '#4C5058',
                        //                 padding: [3, 4],
                        //                 borderRadius: 4
                        //             }
                        //         }
                        //     },
                        //     data: [
                        //         {value: occupyHourOne, name: '充1小时'},
                        //         {value: occupyHourTwo, name: '充2小时'},
                        //         {value: occupyHourSix, name: '充6小时'},
                        //         {value: occupyHourTwelve, name: '充12小时'},
                        //         {value: occupyHourTwentyFour, name: '充24小时'},
                        //         {value: occupyHourN, name: '充1天以上'},
                        //     ]
                        // },

                    ]
                })
            }
        }
    }
</script>
